import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useTTS } from "../../../../../hooks/useTTS";
import { updateSection } from "../../../assignmentSlice";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import CommonPage from "../../common/CommonPage";
import VocaCardBack from "./VocaCardBack";
import VocaCardFront from "./VocaCardFront";

const UnknownCardPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { sectionList, section } = useSelector((state) => state.assignment);

  const { speak } = useTTS();

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const currentPage = pageList[currentIndex] || {
    word: "",
    pron: "",
    syn: "",
    ant: "",
    kor: "",
    eng: "",
    example: "",
    example_translation: "",
    isOpened: false,
  };

  useEffect(() => {
    if (pageList.length > 0) {
      setPageList(section.answer);
      return;
    }

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    setPageList(
      section.question.words.map((word) => ({
        ...word,
        isOpened: false,
        isUnknown: false,
        example_list: word.example.split("\n"),
        example_translation_list: word.example_translation.split("\n"),
      }))
    );
    setCurrentIndex(0);
  }, [section]);

  useEffect(() => {
    speak({ text: currentPage.word });
    setPageList((prev) =>
      prev.map((word, index) => {
        return index === currentIndex ? { ...word, isOpened: false } : word;
      })
    );
  }, [currentIndex]);

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      alert("모르는 단어 학습을 완료했습니다.");
      setCurrentStep(2);
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const clickCard = () => {
    speak({ text: currentPage.word });
    setPageList((prev) =>
      prev.map((word, index) => {
        return index === currentIndex
          ? { ...word, isOpened: !word.isOpened }
          : word;
      })
    );
  };

  const clickSwitch = (checked) => {
    const updatingSection = sectionList.find(
      (section) =>
        section.type === "study" &&
        section.answer.some((word) => word.index === currentPage.index)
    );

    const newAnswer = updatingSection.answer.map((word) => {
      if (word.index === currentPage.index) {
        return { ...word, isUnknown: checked };
      }
      return word;
    });

    dispatch(
      updateSection({
        sectionId: updatingSection.id,
        data: { answer: newAnswer },
      })
    );
  };

  return (
    <CommonPage
      currentPage={currentPage}
      currentIndex={currentIndex}
      totalNo={pageList.length}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      fontFamily='"Noto Sans KR", sans-serif'
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "90%",
          maxWidth: "1300px",
          position: "relative",
          transformStyle: "preserve-3d",
          transition: "transform 0.6s ease",
          transform: currentPage.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
          cursor: "pointer",
        }}
        onClick={clickCard}
      >
        <VocaCardBack currentPage={currentPage} />
        <VocaCardFront
          currentPage={currentPage}
          currentIndex={currentIndex}
          clickSwitch={clickSwitch}
          onSpeak={() => speak({ text: currentPage.word })}
        />
      </div>
    </CommonPage>
  );
};

export default UnknownCardPage;
